import { ReportType } from '@biteinc/enums';

app.OneTimeReportView = app.BaseDetailsView.extend({
  getSchema() {
    const schema = app.BaseDetailsView.prototype.getSchema.apply(this);

    // Only show on the org page
    if (app.site || app.location) {
      delete schema.fields.locationGroupId;
    }

    // Only show on the org and site page
    if (app.location) {
      delete schema.fields.orderChannels;
    }

    return schema;
  },

  checkForUnsavedChanges() {
    return false;
  },

  getFocusFieldName() {
    return undefined;
  },

  _didSaveModel(response) {
    if (response.salesSummaryReport) {
      // TODO Remove this if-case once sales-summary-modal is removed
      const modal = app.modalManager.showModalWithView(
        new app.SalesSummaryView({
          data: response.salesSummaryReport,
          primaryFooterButton: {
            title: 'Email Report',
            isEnabled: true,
            callback: () => {
              const $saveButton = modal.footer.$('button.save');
              const reqId = $saveButton.initLoadingButton(
                $saveButton.html(),
                'Emailing Report...',
                'Emailed Report!',
              );

              const csvOneTimeReport = this.model.clone();
              csvOneTimeReport.save(
                {
                  ...this.fieldGroupView.getValue(),
                  // The SalesSummaryModal report only exists for channels, so if the user requests
                  // an email, we know to send them the channel summary.
                  type: ReportType.SalesSummaryChannel,
                  emailAddresses: [app.sessionUser.get('username')],
                },
                {
                  success: () => {
                    $saveButton.loadingDidFinishSuccessfully(reqId);
                  },
                },
              );
            },
          },
        }),
      );
    } else if (response.downloads?.length) {
      const hasMultiple = response.downloads.length > 1;
      const links = response.downloads
        .map((download) => {
          const label = hasMultiple ? `Download ${download.displayName}` : 'Download Report';
          return `<div class="download-report-row"><a class="btn btn-primary download-report-button" href="${download.url}" target="_blank" rel="noopener" download>${label}</a></div>`;
        })
        .join('');
      new app.AlertView().show('Your report is ready', links);
    } else if (response.message) {
      new app.AlertView().show(response.message);
    }
  },

  _toggleLocationGroupIdsField() {
    const fieldViews = this.fieldGroupView.fieldViewsByField;
    const reportTypeView = fieldViews.type;
    const locationGroupIdView = fieldViews.locationGroupId;
    const salesByLocationGroupIdsView = fieldViews.salesByLocationGroupIds;

    if (!(locationGroupIdView && salesByLocationGroupIdsView)) {
      return;
    }

    if (
      !locationGroupIdView.value ||
      !reportTypeView ||
      reportTypeView.value !== ReportType.SalesSummaryOrg
    ) {
      salesByLocationGroupIdsView.$el.toggle(false);

      return;
    }

    const locationGroup = app.locationGroupList.get(locationGroupIdView.value);

    if (locationGroup && (locationGroup.isOrgWide() || locationGroup.isAllLive())) {
      salesByLocationGroupIdsView.$el.toggle(true);
    } else {
      salesByLocationGroupIdsView.$el.toggle(false);
    }
  },

  render() {
    if (!app.site) {
      if (!app.locationList.hasBeenFetched()) {
        this.listenToOnce(app.locationList, 'reset', () => {
          this.render();
        });
        return this;
      }
      if (!app.locationGroupList.hasBeenFetched()) {
        this.listenToOnce(app.locationGroupList, 'reset', () => {
          this.render();
        });
        return this;
      }
    }

    app.BaseDetailsView.prototype.render.apply(this);

    this.superView.footer.setCloseButtonVisible(false);

    this.listenTo(
      this.fieldGroupView.fieldViewsByField.locationGroupId,
      app.FieldView.Events.FieldDidChangeValue,
      this._toggleLocationGroupIdsField,
    );
    this.listenTo(
      this.fieldGroupView.fieldViewsByField.type,
      app.FieldView.Events.FieldDidChangeValue,
      this._toggleLocationGroupIdsField,
    );
    this._toggleLocationGroupIdsField();

    return this;
  },
});
